import { Grid, Typography, Box, Paper } from '@mui/material';
import {
  Pets as AnimalIcon,
  Yard as CropIcon,
  Webhook as MixedIcon,
  Done as DoneIcon,
  DoNotDisturbOn as FalseIcon,
  Brightness5,
  Brightness6,
  Brightness7,
} from '@mui/icons-material';

import colors from '../../assets/colors';

export default function DetailedInfo(props) {
  return (
    <>
      <Grid
        item
        xs={12}
        lg={5.7}
        xl={5.7}
        sx={{
          backgroundColor: '#118553',
          color: '#FFFFFF',
        }}
        component={Paper}
      >
        <Box textAlign="left" sx={{ py: 4, px: 4 }}>
          <Grid container justifyContent="space-between">
            <Typography variant="h6">Status: </Typography>
            <Typography variant="h6" align="right">
              {props.data?.status !== 'brak' ? (
                <DoneIcon sx={{ color: colors.agroweToxicGreen }} />
              ) : (
                <FalseIcon sx={{ color: colors.redButton }} />
              )}
            </Typography>
          </Grid>
          <Grid container justifyContent="space-between">
            <Typography variant="h6">Typ produkcji: </Typography>
            <Typography variant="h6" align="right">
              {props.data?.productionType === 'animal' && (
                <AnimalIcon sx={{ color: colors.pink }} />
              )}
              {props.data?.productionType === 'crop' && (
                <CropIcon sx={{ color: colors.agroweToxicGreen }} />
              )}
              {props.data?.productionType === 'mixed' && (
                <MixedIcon sx={{ color: colors.brightYellow }} />
              )}
            </Typography>
          </Grid>
          <Grid container justifyContent="space-between">
            <Typography variant="h6">
              Czy użytkownik znajduje się w branży wykluczonej:
            </Typography>
            <Typography variant="h6" align="right">
              {props.data?.isProductionExcluded ? (
                <DoneIcon sx={{ color: colors.agroweToxicGreen }} />
              ) : (
                <FalseIcon sx={{ color: colors.redButton }} />
              )}
            </Typography>
          </Grid>
          <Grid container justifyContent="space-between">
            <Typography variant="h6">
              Wielkość produkcji roślinnej (ha):
            </Typography>
            <Typography variant="h6" align="right">
              {props.data?.fieldsArea}
            </Typography>
          </Grid>
          <Grid container justifyContent="space-between">
            <Typography variant="h6">Grupa dochodowa: </Typography>
            <Typography variant="h6" align="right">
              {props.data?.incomeGroup === 'micro' && (
                <Brightness5 sx={{ color: '#BF360C' }} />
              )}
              {props.data?.incomeGroup === 'medium' && (
                <Brightness6 sx={{ color: '#FB8C00' }} />
              )}
              {props.data?.incomeGroup === 'makro' && (
                <Brightness7 sx={{ color: '#FFAB40' }} />
              )}
            </Typography>
          </Grid>
          <Grid container justifyContent="space-between">
            <Typography variant="h6">Dochód z dopłat (zł): </Typography>
            <Typography variant="h6" align="right">
              {Number(props.data?.directPaymentIncome.toFixed(2)) || ''}
            </Typography>
          </Grid>
          <Grid container justifyContent="space-between">
            <Typography variant="h6">
              Dochód z produkcji roślinnej (zł):{' '}
            </Typography>
            <Typography variant="h6" align="right">
              {Number(props.data?.cropProductionIncome.toFixed(2)) || ''}
            </Typography>
          </Grid>
          <Grid container justifyContent="space-between">
            <Typography variant="h6">
              Dochód z produkcji zwierzęcej (zł):{' '}
            </Typography>
            <Typography variant="h6" align="right">
              {Number(props.data?.animalProductionIncome.toFixed(2)) || ''}
            </Typography>
          </Grid>
          <Grid container justifyContent="space-between">
            <Typography variant="h6">Pozostały dochód (zł): </Typography>
            <Typography variant="h6" align="right">
              {Number(props.data?.additionalIncome.toFixed(2)) || ''}
            </Typography>
          </Grid>
        </Box>
      </Grid>
    </>
  );
}
